import React, { useState } from 'react';
import Modal from '../Modal/index.js';
import './UpdatePhotoModal.css';
import { INSPECTION_STATUS_VERDICT } from '../../utils/constants.js';
import PhotoUploader from '../PhotoUploader.js/index.js';

const { REJECTED, APPROVED, PENDING } = INSPECTION_STATUS_VERDICT;

const UpdatePhotoModal = ({ 
    isOpen, 
    onClose, 
    photo,
    onPhotoUpdate
}) => {
    const [isUpdating, setIsUpdating] = useState(false);

    const handlePhotoSelected = async (selectedPhotos) => {
        if (selectedPhotos.length === 0) return;

        try {
            setIsUpdating(true);
            
            await onPhotoUpdate(photo, selectedPhotos[0]);
            
            onClose();
            
        } catch (error) {
            console.error('Error updating photo:', error);
        } finally {
            setIsUpdating(false);
        }
    };

    const handleCancel = () => {
        onClose();
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title="Actualizar Foto"
            size="large"
            showCloseButton={true}
            closeOnBackdropClick={true}
        >
            <div className="update-photo-modal-content">
                <div className="current-photo-info">
                    <h4>Foto Actual</h4>
                    <div className="current-photo-display">
                        <img 
                            src={photo?.url} 
                            alt={photo?.label || 'Foto actual'} 
                            className="current-photo-thumbnail"
                        />
                        <div className="current-photo-details">
                            <p><strong>Nombre:</strong> {photo?.photoName || 'Sin nombre'}</p>
                            <p><strong>Estado:</strong> 
                                <span className={`status-badge ${photo?.status || PENDING}`}>
                                    {photo?.status === REJECTED ? 'Rechazada' : 
                                     photo?.status === APPROVED ? 'Aprobada' : 'Pendiente'}
                                </span>
                            </p>
                            {photo?.rejectionReason && (
                                <p><strong>Motivo de rechazo:</strong> {photo.rejectionReason}</p>
                            )}
                        </div>
                    </div>
                </div>

                <PhotoUploader
                    maxPhotos={1}
                    onPhotosSelected={handlePhotoSelected}
                    onCancel={handleCancel}
                    title="Seleccionar Nueva Foto"
                    description="Selecciona la foto que reemplazará la actual"
                    acceptMultiple={false}
                    showPreview={true}
                    allowRemove={true}
                />

                {isUpdating && (
                    <div className="update-loading">
                        <div className="loading-spinner"></div>
                        <p>Actualizando foto...</p>
                    </div>
                )}
            </div>
        </Modal>
    );
};

export default UpdatePhotoModal;